<template>
  <base-input
    v-show="!hidden"
    v-if="isText"
    :read-only="readOnly"
    :value="value"
    :isSavable="isSavable"
    @form-item-changed="onChange"
    @keyup-enter="handleEnterKey"
    @keyup-escape="handleEscapeKey"
  />
  <number-input-field
    v-else-if="isNumber"
    v-show="!hidden"
    :read-only="readOnly"
    :value="value"
    :name="name"
    :id="id"
    :placeholder="placeholder"
    :isSavable="isSavable"
    @form-item-changed="onChange"
    @keyup-enter="handleEnterKey"
    @keyup-escape="handleEscapeKey"
    @set-table-loader="handleTableLoader"
  ></number-input-field>
  <base-datalist
    v-show="!hidden"
    v-else-if="isDropdown"
    v-bind="dropdownProps"
    @form-item-changed="onChange"
  ></base-datalist>
  <date-time v-show="!hidden" v-else-if="isDateTime" v-bind="dateTimeProps" @form-item-changed="onChange"></date-time>
  <date-time v-show="!hidden" v-else-if="isDate" v-bind="dateProps" @form-item-changed="onChange"></date-time>
  <cameras v-show="!hidden" v-else-if="isCameras" v-bind="camerasProps" @form-item-changed="onChange"></cameras>
  <checkbox v-show="!hidden" v-else-if="isCheckbox" v-bind="checkboxProps" @form-item-changed="onChange"></checkbox>
  <div v-else>{{ listValue }}</div>
</template>

<script>
import BaseInput from '../../form/controls/BaseInput'
import NumberInputField from './NumberInputField.vue'
import BaseDatalist from '../../form/controls/BaseDatalist.vue'
import editableFieldMixin from './editable-field-mixin'
import DateTime from '../../form/controls/DateTime.vue'
import Cameras from '../../form/controls/Cameras.vue'
import Checkbox from '../../form/controls/Checkbox.vue'

import { get } from 'lodash'
import { FIELD_TYPES } from '../../../consts'

export default {
  name: 'EditableFieldWrapper',
  mixins: [editableFieldMixin],
  components: {
    Checkbox,
    BaseInput,
    NumberInputField,
    BaseDatalist,
    DateTime,
    Cameras,
  },
  props: ['listValue', 'row', 'name', 'data'],
  data() {
    return {}
  },
  computed: {
    idMainTable() {
      return get(this.row, 'ROW_KEY')
    },
    isNumber() {
      return this.type === FIELD_TYPES.NUMBER
    },
    isText() {
      return [FIELD_TYPES.EMAIL, FIELD_TYPES.RICH_TEXT, FIELD_TYPES.TEXT].includes(this.type)
    },
    isDropdown() {
      return this.type === FIELD_TYPES.DROPDOWN
    },
    isDateTime() {
      return this.type === FIELD_TYPES.DATETIME
    },
    dropdownValue() {
      return get(this.row, `${this.name}-ID`)
    },
    isDate() {
      return this.type === FIELD_TYPES.DATE
    },
    isCameras() {
      return this.type === FIELD_TYPES.CAMERAS
    },
    isCheckbox() {
      return this.type === FIELD_TYPES.CHECKBOX
    },
    dropdownProps() {
      return {
        id: this.id,
        multiple: this.multiple,
        clearable: this.clearable,
        disabled: this.disabled,
        taggable: this.taggable,
        name: this.name,
        value: this.value,
        defaultValue: this.defaultValue,
        list: this.list,
        autocomplete: this.autocomplete,
        idForm: this.idForm,
        filterExp: this.filterExp,
        listExp: this.listExp,
        fieldName: this.name,
        placeholder: this.placeholder,
        readOnly: this.readOnly,
        dropdownOnlyOne: this.dropdownOnlyOne,
      }
    },
    dateTimeProps() {
      return {
        id: this.id,
        multiple: this.multiple,
        clearable: this.clearable,
        disabled: this.disabled,
        taggable: this.taggable,
        name: this.name,
        value: this.value,
        defaultValue: this.defaultValue,
        list: this.list,
        autocomplete: this.autocomplete,
        idForm: this.idForm,
        filterExp: this.filterExp,
        listExp: this.listExp,
        fieldName: this.name,
        placeholder: this.placeholder,
        readOnly: this.readOnly,
        dropdownOnlyOne: this.dropdownOnlyOne,
        formats: { ...this.formats, isTimeSelect: true },
        type: this.type,
      }
    },
    dateProps() {
      return {
        id: this.id,
        multiple: this.multiple,
        clearable: this.clearable,
        disabled: this.disabled,
        taggable: this.taggable,
        name: this.name,
        value: this.value,
        defaultValue: this.defaultValue,
        list: this.list,
        autocomplete: this.autocomplete,
        idForm: this.idForm,
        filterExp: this.filterExp,
        listExp: this.listExp,
        fieldName: this.name,
        placeholder: this.placeholder,
        readOnly: this.readOnly,
        dropdownOnlyOne: this.dropdownOnlyOne,
        formats: this.formats,
      }
    },
    camerasProps() {
      return {
        field: this.field,
        value: this.value,
        multiple: this.multiple,
        name: this.name,
        readOnly: this.readOnly,
        subformId: this.idForm,
        filter: JSON.stringify({
          where: {
            id: { $in: Array.isArray(this.value) ? this.value : [this.value] },
          },
        }),
      }
    },
    checkboxProps() {
      return {
        name: this.name,
        label: this.$i18n.t(this.label),
        value: this.value,
        readOnly: this.readOnly,
      }
    },
  },
  methods: {
    onChange(payload) {
      this.value = payload
    },
    handleEnterKey() {
      this.$emit('enter-pressed')
    },
    handleEscapeKey() {
      this.$emit('escape-pressed')
    },
    handleTableLoader(value) {
      this.$emit('set-table-loader', value)
    },
  },
}
</script>

<style scoped lang="scss"></style>
